const DEFAULT_SYSTEM_PAGE_SIZE = 10
const DEFAULT_SYSTEM_PAGE_NO = 1
const DEFAULT_SYSTEM_LIST = []

const ALL = 'All'
const SUBMITTEDFORENPHASE = 'Submitted for Enphase Review'
const APPROVEDBYENPHASE = 'Approved by Enphase'
const REJECTEDBYENPHASE = 'Rejected by Enphase'
const EVIDENCEREPORTMAILED = 'Evidence report mailed'
const UNENROLLED = 'Unenrolled'

const statusMapper = {
  'All': '',
  'Submitted for Enphase Review': 'submitted',
  'Approved by Enphase': 'approved',
  'Rejected by Enphase': 'rejected',
  'Evidence report mailed': 'report_generated',
  'Unenrolled': 'unenrolled'
}

const getDropDownValues = () => {
  return [ALL, SUBMITTEDFORENPHASE, APPROVEDBYENPHASE, REJECTEDBYENPHASE, EVIDENCEREPORTMAILED, UNENROLLED]
}

const systemsTableHeadings = [
  {
    id: 'enphaseSiteId',
    header: 'ENPHASE SITE ID',
    isLink: true,
  },
  {
    id: 'homeOwnerFullName',
    header: 'HOME OWNER FULL NAME',
  },
  {
    id: 'committedKW',
    header: 'COMMITTED POWER (kW)',
  },
  {
    id: 'installerName',
    header: 'INSTALLER NAME',
  },
  {
    id: 'status',
    header: 'APPLICATION STATUS',
    isActive: true,
    isDropdown: true,
    dropDownValues: getDropDownValues()
  },
  {
    id: 'timestamp',
    header: 'TIME STAMP',
    isPopover: true,
    popoverContent: 'This is the date and time when an application reaches a particular stage in the enrolment process'
  },
]

export {
  systemsTableHeadings,
  DEFAULT_SYSTEM_PAGE_SIZE,
  DEFAULT_SYSTEM_PAGE_NO,
  DEFAULT_SYSTEM_LIST,
  ALL,
  SUBMITTEDFORENPHASE,
  APPROVEDBYENPHASE,
  REJECTEDBYENPHASE,
  EVIDENCEREPORTMAILED,
  statusMapper
}
